// @flow

import type {Gender} from './gender'

export type CustomerSummary = {
  id: ?number,
  gender: Gender,
  firstName: ?string,
  surnamePrefix: ?string,
  surname: ?string,
  dateOfBirth: ?Date
}

const buildCustomerSummary = (): CustomerSummary => {
  return {
    id: null,
    gender: null,
    firstName: null,
    surnamePrefix: null,
    surname: null,
    dateOfBirth: null
  }
}

export {
  buildCustomerSummary
}



// WEBPACK FOOTER //
// ./src/types/customer-summary.js